import { FlightPolicyDeviation } from './flights/search'

export type SeatMapSegmentsSelection = Record<number, SeatMapSeat[]>

export type SeatMapFlightResultSelection = Record<string, SeatMapSegmentsSelection>

// eslint-disable-next-line no-restricted-syntax
export enum SEAT_STATUSES {
	// T - means taken
	T = 'T',
	// A - means available
	A = 'A',
	// N - means no seat at this location,
	N = 'N',
}

// eslint-disable-next-line no-restricted-syntax
export enum SEAT_CHARACTERISTICS {
	// OW - means overwing seat(s)
	OW = 'OW',
	// E - means seat doesn't exist
	E = '8',
	// L - means Leg space seat
	L = 'L',
	// 'CH' - chargable seat
	CH = 'CH',
	// 'A' - Aisle Seat
	A = 'A',
	// 'O' - Preferential position
	O = 'O',
	// '9' - 'Center seat (not window, not aisle)'
	CENTER_SEAT = '9',
	// 'W' - Window seat
	W = 'W',
}

export interface SeatMapInfoItem<T = string> {
	code: T
	description: string
}

export interface SeatMapSeat {
	amount: number
	converted_amount: number
	characteristics: SeatMapInfoItem<SEAT_CHARACTERISTICS>[]
	column: string
	seatKey: string
	status: SeatMapInfoItem<SEAT_STATUSES>
	number: string
	in_policy: boolean
	policyDeviations: FlightPolicyDeviation[]
	airportLabel?: string
	segmentId?: string
	traveler_id?: number
	travelerDetails?: TravelerDetail[]
	seat_key?: string
	flight_segment_id?: string
	description?: string | null
	/** Becomes a boolean after the seat booking attempt */
	is_success?: boolean | null
}

interface TravelerDetail {
	amount: number
	convertedAmount: number
	inPolicy: boolean
	policyDeviations: FlightPolicyDeviation[]
	travelerId: number
}
